/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_PlaceholderInputs */

const en_admin_tickets_reply_placeholder = /** @type {(inputs: Admin_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a reply...`)
};

/**
* | output |
* | --- |
* | "Write a reply..." |
*
* @param {Admin_Tickets_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_placeholder = /** @type {((inputs?: Admin_Tickets_Reply_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_reply_placeholder(inputs)
});
export { admin_tickets_reply_placeholder as "admin.tickets.reply_placeholder" }